import { IDeleteUnidadeUseCase } from "../../../presentation/useCases/delete/delete_unidade_use_case";
import { IIncorporacaoRepository } from "../../repositories/incorporacao_repositories";

/**
 * DeleteUnidadeUseCase
 */

export class DeleteUnidadeUseCase implements IDeleteUnidadeUseCase {
  constructor(private readonly repository: IIncorporacaoRepository) {

  }

  async deleteUnidade(idUnidade: number): Promise<void> {
    await this.repository.deleteUnidade(idUnidade);

  }

}
